<div class="app-container">
    <router-outlet></router-outlet>
    <app-spinner *ngIf="isShow$ | async"></app-spinner>
</div>